import axios from "axios";
import authService from "./authService";
const USER_API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const ORDER_BASE_ROUTE = "/api/v1/orders/techpack";
const PREORDER_BASE_ROUTE = "/api/v1/preorders/techpack";
const TECHPACK_BASE_ROUTE = "/api/v1/techpacks";

class TechpackService {
  getTechpackPdfLink(data) {
    return axios.post(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/techpack/generate/pdf`,
      data,
      // timeout 1000000ms = 1000s = 16.666666666666668 minutes
      { ...authService.getAuthHeader(), timeout: 1000000 }
    );
  }

  getPreOrderTechpack(data) {
    return axios.post(
      `${USER_API_BASE_URL}${PREORDER_BASE_ROUTE}`,
      data,
      authService.getAuthHeader()
    );
  }

  getOrderTechpack(data) {
    return axios.post(
      `${USER_API_BASE_URL}${ORDER_BASE_ROUTE}`,
      data,
      authService.getAuthHeader()
    );
  }

  updateProductionArtworkCalibrationColors(data) {
    return axios.put(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/item/artwork/production/calibration`,
      data,
      authService.getAuthHeader()
    );
  }

  updateProductionArtworkBackgroundColor(data) {
    return axios.put(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/item/artwork/production/background`,
      data,
      authService.getAuthHeader()
    );
  }

  updatePreviewArtworkBackgroundColor(data) {
    return axios.put(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/item/artwork/preview/background`,
      data,
      authService.getAuthHeader()
    );
  }

  updateOriginalArtworkBackgroundColor(data) {
    return axios.put(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/item/artwork/original/background`,
      data,
      authService.getAuthHeader()
    );
  }

  updateProductionArtwork(data) {
    return axios.put(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/item/artwork/production/asset`,
      data,
      authService.getAuthHeader()
    );
  }

  removeProductionArtwork(data) {
    return axios.delete(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/item/artwork/production/asset`,
      { data: data, ...authService.getAuthHeader() }
    );
  }

  setProjectNumber(data) {
    return axios.put(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/techpack/projectNumber`,
      data,
      authService.getAuthHeader()
    );
  }

  setCarbonNeutral(data) {
    return axios.put(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/techpack/carbonneutral`,
      data,
      authService.getAuthHeader()
    );
  }

  setVersion(data) {
    return axios.put(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/item/version`,
      data,
      authService.getAuthHeader()
    );
  }

  setCustomerNumber(data) {
    return axios.put(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/techpack/customerNumber`,
      data,
      authService.getAuthHeader()
    );
  }

  setSize(data) {
    return axios.post(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/item/sizes`,
      data,
      authService.getAuthHeader()
    );
  }

  setCustomColorReference(data) {
    return axios.put(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/item/customColorReference`,
      data,
      authService.getAuthHeader()
    );
  }

  updateAdditionalOptionsField(data, field) {
    return axios.put(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/item/${field}`,
      data,
      authService.getAuthHeader()
    );
  }

  setPriceOption(data) {
    return axios.put(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/item/priceOption`,
      data,
      authService.getAuthHeader()
    );
  }

  setSku(data) {
    return axios.put(
      `${USER_API_BASE_URL}${TECHPACK_BASE_ROUTE}/item/sku`,
      data,
      authService.getAuthHeader()
    );
  }
}

const instance = new TechpackService();
export default instance;
